import {
  mannequin1,
  mannequin2,
  mannequin3,
  mannequin4,
  mannequin5,
} from "../../assets";

export const newArrivalData = [
  {
    id: 101,
    title: "New Arrival-1",
    price: "24.99",
    image: mannequin1,
    quantity: 1
  },
  {
    id: 102,
    title: "New Arrival-2",
    price: "24.99",
    image: mannequin2,
    quantity: 1
  },
  {
    id: 103,
    title: "New Arrival-3",
    price: "24.99",
    image: mannequin3,
    quantity: 1
  },
  {
    id: 104,
    title: "New Arrival-4",
    price: "24.99",
    image: mannequin4,
    quantity: 1
  },
  {
    id: 105,
    title: "New Arrival-5",
    price: "24.99",
    image: mannequin5,
    quantity: 1
  },
  {
    id: 106,
    title: "New Arrival-6",
    price: "24.99",
    image: mannequin2,
    quantity: 1
  },
];
